import { AppointmentDetailsInvitations } from "./AppointmentDetailsInvitations";
import { AppointmentDetailsMenu } from "./AppointmentDetailsMenu";
import { TTimeOff } from "@bsm/graphql";

export const AppointmentDetailsToolbox = (props: AppointmentDetailsToolboxProps) => {

    return (
        <div className="flex">
            <AppointmentDetailsInvitations {...props} />

            <AppointmentDetailsMenu {...props} />
        </div>
        
    )
}

export type AppointmentDetailsToolboxProps = Partial<TTimeOff> & {
    onUpdated?: () => void
    onDeleted?: () => void
}

